import { useEffect, useState } from 'react';
import useWebsocket from 'react-use-websocket';
import ServicePaths from '../bridge/utils/ServicePaths';
import {
  CPCLiveMessageType,
  type CPCQueueStateMessage,
} from '../bridge/utils/CPCLiveMessages';

type QueueState = CPCQueueStateMessage | null;

const useCPCDaemonQueueWebsocket = () => {
  const url = ServicePaths.DATA.Websocket;
  const [queueState, setQueueState] = useState<QueueState>(null);
  const { lastMessage, readyState, getWebSocket } = useWebsocket(url, {
    shouldReconnect: () => true,
    reconnectAttempts: Infinity,
    reconnectInterval: (attempt) => Math.min(30_000, 1000 * 2 ** attempt),
  });

  useEffect(() => {
    if (!lastMessage) return;
    try {
      const data = JSON.parse(lastMessage.data) as { type?: string };
      if (data.type === CPCLiveMessageType.QueueState) {
        setQueueState(data as CPCQueueStateMessage);
      }
    } catch {
      // ignore non-JSON or unrelated messages on this shared socket (logs etc.)
    }
  }, [lastMessage]);

  useEffect(() => {
    return () => {
      const ws = getWebSocket();
      if (ws && (ws.OPEN || ws.CONNECTING)) {
        ws.close();
      }
    };
  }, [getWebSocket]);

  return {
    queueState,
    isConnected: readyState === 1,
  };
};

export default useCPCDaemonQueueWebsocket;
